import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import withMemo from '../../decorators/withMemo';
import { generateFieldsProps, getFieldTranslations, compileRules, defineField } from '../../helpers/FormHelpers';
import LoginTemplate from '../../templates/Login';
import Password from '../../components/form/fields/Password';
import { useFooter, useHeader } from '../../hooks/useAppLayout';
import routes, { Router } from '../../routes';
import sagas from './sagas';
import { actions, selectors } from './redux';
var Login = function Login() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useDispatch();
  var headerProps = useHeader();
  var footerProps = useFooter();
  var router = useRouter();
  var login = useSelector(selectors.login);
  var submitErrors = login == null ? void 0 : login.errors;
  var submitSuccess = login == null ? void 0 : login.success;
  var submitPending = login == null ? void 0 : login.pending;
  var layoutProps = {
    theme: {
      maxWidth: 440
    }
  };
  var pageTitleProps = {
    text: t('login')
  };
  var sections = [{
    type: 'fields',
    content: [defineField({
      name: 'email',
      validation: 'required|email',
      props: {
        type: 'text'
      }
    })]
  }, {
    type: 'fields',
    content: [defineField({
      name: 'password',
      validation: 'required',
      component: Password,
      props: {
        type: 'password'
      }
    })]
  }, {
    type: 'fields',
    content: [defineField({
      name: 'code',
      validation: 'required',
      props: {
        type: 'text'
      }
    })]
  }];
  var fields = sections.filter(function (section) {
    return section.type === 'fields';
  }).map(function (thisFields) {
    return thisFields.content;
  }).flat();
  var rules = compileRules(fields);
  var formLoginProps = useMemo(function () {
    return {
      fieldsProps: generateFieldsProps(fields, function (field) {
        var fieldProps = getFieldTranslations(t, "login_form_".concat(field.name));
        return fieldProps;
      }),
      messages: {
        required: t('form_error_required'),
        email: t('form_error_email')
      },
      submitLabel: t('login_form_submit_label'),
      submitPendingLabel: t('form_submit_pending_label'),
      submitSuccessLabel: t('form_submit_success_label'),
      forgottenLinkProps: {
        href: Router.getRouteUrl(routes.forgotPassword)
      },
      forgottenLinkLabel: t('forgot_your_password'),
      backLinkProps: {
        linkProps: {
          onClick: function onClick() {
            return router.back();
          }
        }
      },
      onSubmit: function onSubmit(payload) {
        return dispatch(actions.login(payload));
      },
      submitErrors: submitErrors,
      submitSuccess: submitSuccess,
      submitPending: submitPending,
      backLinkLabel: t('back'),
      sections: sections,
      fields: fields,
      rules: rules
    };
  }, [dispatch, fields, router, rules, sections, submitErrors, submitPending, submitSuccess, t]);
  var loginTemplateProps = {
    headerProps: headerProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    pageTitleProps: pageTitleProps,
    formLoginProps: formLoginProps
  };
  return /*#__PURE__*/React.createElement(LoginTemplate, loginTemplateProps);
};
Login.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(sagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
Login.propTypes = {};
Login.defaultProps = {};
export default withMemo()(Login);